// Create Sub-Query Use Case
import { QueriesRepository } from "../repositories/QueriesRepository";
import { QueryEntity, CreateSubQueryParams } from "../entities/QueryEntity";
import { Result } from "../common/Result";

export class CreateSubQueryUseCase {
  constructor(private repository: QueriesRepository) {}

  async execute(params: CreateSubQueryParams): Promise<Result<QueryEntity>> {
    try {
      // Business logic validation
      if (!params.title || params.title.trim().length < 3) {
        return Result.fail("Title must be at least 3 characters");
      }

      if (params.description && params.description.length > 1000) {
        return Result.fail("Description cannot exceed 1000 characters");
      }

      if (!params.parentQueryId) {
        return Result.fail("Parent query ID is required");
      }

      const subQuery = await this.repository.createSubQuery(params);
      return Result.ok(subQuery);
    } catch (error: any) {
      return Result.fail(error.message || "Failed to create sub-query");
    }
  }
}

